export default "__VITE_ASSET__B6Kk08fr__"